import {type FC} from 'react';
import {cn} from '@/lib/utils';
import {Logo} from '@/components/ui/logo/logo';

interface FeaturedBadgeProps {
  className?: string;
}

/**
 * Displays a "Featured" badge with the Wayra logo mark and text in primary
 * orange. Shown inline next to event names when an event has editorial content.
 */
export const FeaturedBadge: FC<FeaturedBadgeProps> = ({className}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-primary-500 flex-shrink-0',
        className
      )}
    >
      <Logo markOnly fillClassName="fill-primary-500" className="h-3 w-auto" />
      <span className="text-xs font-medium tracking-wide">Featured</span>
    </span>
  );
};
